import React from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, ArrowLeft, Mail, Phone, MessageCircle, Clock } from 'lucide-react';
import '../styles/modern.css';

export const ContactSupport: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ background: 'var(--color-gray-50)' }}>
      {/* Header */}
      <div style={{
        background: 'var(--color-primary)',
        padding: '24px 0'
      }}>
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 text-white">
              <div style={{
                background: 'rgba(255, 255, 255, 0.15)',
                padding: '10px',
                borderRadius: '10px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }}>
                <TruckIcon className="w-6 h-6" />
              </div>
              <span className="text-xl font-bold">Transportation Safety Platform</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-sm mb-8"
          style={{ color: 'var(--color-gray-600)' }}
        >
          <ArrowLeft className="w-4 h-4" />
          Back to login
        </Link>

        <div style={{
          background: '#fbf9f4',
          borderRadius: 'var(--radius-xl)',
          padding: '48px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
          border: '1px solid var(--color-gray-200)'
        }}>
          <div className="flex items-center gap-4 mb-8">
            <div style={{
              width: '56px',
              height: '56px',
              background: 'var(--color-primary)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <MessageCircle className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold" style={{ color: 'var(--color-gray-900)' }}>
                Contact Support
              </h1>
              <p className="text-muted">We're here to help</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {/* Email Support */}
            <div style={{
              padding: '24px',
              borderRadius: 'var(--radius-lg)',
              border: '1px solid var(--color-gray-200)',
              background: 'var(--color-gray-50)'
            }}>
              <div className="flex items-center gap-3 mb-4">
                <Mail className="w-5 h-5" style={{ color: 'var(--color-primary)' }} />
                <h3 className="font-semibold" style={{ color: 'var(--color-gray-900)' }}>Email Support</h3>
              </div>
              <p className="text-sm text-muted mb-3">For general inquiries and technical support</p>
              <a 
                href="mailto:support@tsap.ai" 
                className="font-medium"
                style={{ color: 'var(--color-primary)' }}
              >
                support@tsap.ai
              </a>
            </div>

            {/* Phone Support */}
            <div style={{
              padding: '24px',
              borderRadius: 'var(--radius-lg)',
              border: '1px solid var(--color-gray-200)',
              background: 'var(--color-gray-50)'
            }}>
              <div className="flex items-center gap-3 mb-4">
                <Phone className="w-5 h-5" style={{ color: 'var(--color-primary)' }} />
                <h3 className="font-semibold" style={{ color: 'var(--color-gray-900)' }}>Phone Support</h3>
              </div>
              <p className="text-sm text-muted mb-3">For urgent issues (Enterprise customers)</p>
              <span className="font-medium" style={{ color: 'var(--color-gray-900)' }}>
                1-800-TSAP-HELP
              </span>
            </div>
          </div>

          {/* Support Hours */}
          <div style={{
            padding: '24px',
            borderRadius: 'var(--radius-lg)',
            border: '1px solid var(--color-gray-200)',
            background: 'var(--color-gray-100)'
          }}>
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-5 h-5" style={{ color: 'var(--color-primary)' }} />
              <h3 className="font-semibold" style={{ color: 'var(--color-gray-900)' }}>Support Hours</h3>
            </div>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="font-medium" style={{ color: 'var(--color-gray-900)' }}>Standard Support</p>
                <p className="text-muted">Monday - Friday: 9 AM - 6 PM EST</p>
              </div>
              <div>
                <p className="font-medium" style={{ color: 'var(--color-gray-900)' }}>Enterprise Support</p>
                <p className="text-muted">24/7 for critical issues</p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-8" style={{ borderTop: '1px solid var(--color-gray-200)' }}>
            <h3 className="font-semibold mb-4" style={{ color: 'var(--color-gray-900)' }}>Frequently Asked Questions</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <strong>How do I reset my password?</strong>
                <p className="text-muted">
                  Click "Forgot password?" on the login page and enter your email address.
                </p>
              </li>
              <li>
                <strong>How do I add users to my company account?</strong>
                <p className="text-muted">
                  Account administrators can invite users from the Settings {'>'} User Management page.
                </p>
              </li>
              <li>
                <strong>Where does the carrier data come from?</strong>
                <p className="text-muted">
                  We source data from official DOT/FMCSA databases, updated regularly.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;
